import setFullbanner from './home/1_fullbanner';
import setIconsVertical from './home/icons_vertical';
import setBannersLinha from './home/home_banner_linha';
import CategoryTabs from './home/3_category_tabs';
import setCarousel from '../components/carousel';
//addImports

import setTopBar from '../components/topBar';
import handleConditionalLazy from '../components/conditionalLazy';
import setBannersLinhaWithText from './home/home_banner_linha_text';

const Home = {
  init: function () {
    setTopBar();
    handleConditionalLazy();

    setFullbanner()
		setIconsVertical();
		setBannersLinhaWithText();
		CategoryTabs.init();
		setBannersLinha();
		setCarousel();
		//calls
  },
};

window.addEventListener('DOMContentLoaded', () => {
  Home.init();
});
